import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Text } from '@pairy/pds-react';

import { Z_INDEX } from '@/constants/zIndex';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
`;

export const Card = styled.aside<{ isAnimated: boolean; isClosing: boolean }>`
  position: relative;
  overflow: hidden;
  width: 320px;

  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.elevation.md};

  ${({ isAnimated, isClosing }) => {
    if (isClosing) {
      return css`
        animation: ${slideOut} 0.15s ease-in-out forwards;
      `;
    }

    return (
      isAnimated &&
      css`
        animation: ${slideUp} 0.15s ease-in-out;
      `
    );
  }}
`;

export const ThumbnailWrapper = styled.div`
  position: relative;
  width: 100%;
  /* 업데이트 이미지 원본 비율(651 x 238) */
  padding-top: 36.6%;
  background-color: ${({ theme }) => theme.colors.zinc_100};
  border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: ${Z_INDEX.onTop};

  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.zinc_700};
  border-radius: 50%;
  opacity: 0.8;
  transition: opacity 0.15s ease-in-out;

  &:hover {
    opacity: 1;
  }
`;

export const Description = styled(Text)`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: keep-all;
`;
